import GlobalEvents from "base/GlobalEvents";

export function handleStickyNav() {
    let $window = $(window);
    let $header = $('.js-header');

    let lastScroll = $window.scrollTop();
    let currentOffset = 0;

    $(window).on("scroll", function () {
        updateStickyNav();

        let scroll = $window.scrollTop();

        let diff = lastScroll - scroll;
        let height;

        height = $header.outerHeight();

        let bodyOffset = parseInt($('body').css('padding-top'));

        currentOffset = Math.min(0, Math.max(-height, currentOffset + diff));

        if (scroll <= 0) {
            currentOffset = 0;
        }

        if (scroll < bodyOffset) {
            currentOffset = -scroll;
        }

        lastScroll = scroll;

        if (currentOffset === 0) {
            $header.css("transform", "");
        } else {
            $header.css("transform", "translateY(" + currentOffset + "px)");
        }

        GlobalEvents.emit('updatedStickyNavOffset', currentOffset);

    }).on("resize", function () {
        lastScroll = $window.scrollTop();
        currentOffset = 0;
    });

    $(window).trigger("scroll");
}

export function updateStickyNav() {
    let scrollTop = $(window).scrollTop();

    if (scrollTop === 0) {
        $('.js-header').removeClass('header--sticky');
        $('body').removeClass('sticky-header');
        return;
    }

    if (scrollTop > $(".js-header").outerHeight()) {
        $('.js-header').addClass('header--sticky');
        $('body').addClass('sticky-header');
    }
}
